
import { mapGetters } from 'vuex'
import { FORMER_ICHRA_MESSAGE, isFormerIchra } from '~/util/former-ichra'
export default {
    data () {
        return { formerIchraMessage: FORMER_ICHRA_MESSAGE }
    },
    computed: {
        // canAgent also arrives via the common mixin; mapped here too so the
        // component stands on its own under test.
        ...mapGetters(['client', 'crmBase', 'canAgent']),
        formerIchra () {
            return isFormerIchra(this.client)
        },
    },
}
